import { schema } from 'normalizr';

import { SCHEMA_TYPE_TRANSFORMS } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';

const internalTransformSchema = new schema.Entity(SCHEMA_TYPE_TRANSFORMS, {
  owner: userSchema,
  org: orgSchema,
});

const transformSchema = new schema.Entity(SCHEMA_TYPE_TRANSFORMS, {
  owner: userSchema,
  org: orgSchema,
  transform: internalTransformSchema,
});

export default transformSchema;
